/** True when simplified (keyset) paging applies for this user and setting. Operators are excluded. */
export function isSimplifiedPagingEnabledForRole(settingEnabled: boolean, role: string): boolean
{
  if (!settingEnabled)
  {
    return false;
  }
  return role === 'ROLE_PROGRAM_LEAD' || role === 'ROLE_PROGRAM_SUPPORT' ||
    role === 'ROLE_CARE_COORDINATOR' || role === 'ROLE_COMMUNITY_COORDINATOR';
}
